<template>
<div>
    <h3>Admin Page</h3>
    <div>
        <b-nav tabs fill>
            <b-nav-item :active="active==='users'" @click="active='users'">
                Users
            </b-nav-item>
            <b-nav-item :active="active==='condition'" @click="active='condition'">
                Condition
            </b-nav-item>
            <b-nav-item :active="active==='download'" @click="active='download'">
                Download
            </b-nav-item>
        </b-nav>
    </div>
    <div v-if="active==='users'"><userlist></userlist></div>
    <div v-if="active==='condition'"><condition></condition></div>
    <div v-if="active==='download'"><download></download></div>
</div>
</template>
<script>
import Userlist from './Userlist.vue';
import Condition from './Condition.vue';
import DownloadData from './DownloadData.vue';

export default {
  data() {
    return {
      active: 'users',
    };
  },
  components: {
    userlist: Userlist,
    condition: Condition,
    download: DownloadData,
  },
};
</script>
